import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL: string = import.meta.env.VITE_TEST_QSP_BASE_URL;

export interface StudentAttendance {
  student_id: number;
  name: string;
  attended: boolean;
  batchplan: string;
}

export const AttendanceApiSlice = createApi({
  reducerPath: "attendanceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getAttendance: builder.query<
      StudentAttendance[],
      { batchId: string; date: string }
    >({
      query: ({ batchId, date }) => ({
        url: `/get-batchstu-topbrains`,
        params: { batchid: batchId, date },
      }),
      transformResponse: (response: { data: StudentAttendance[] }) =>
        response.data ?? [],
    }),
  }),
});

export const { useGetAttendanceQuery, useLazyGetAttendanceQuery } =
  AttendanceApiSlice;
